import axios from "axios";
import { IChangePassword } from "../models/changePasswordModels";
import { localStorageItem } from "../../utils/localStorage";
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
const API_URL = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_API_URL;

export const changePassword = (data: IChangePassword) => {
  const url = API_URL + "/users/password";
  return axios.patch(url, data);
};
